import { COLORS } from '@constants';
import { Button, Typography } from '@ui';
import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0px;
    gap: 24px;
    width: 454px;
    height: 420px;
`;

export const ChartCard = styled.div`
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    padding: 24px;
    gap: 24px;
    width: 454px;
    height: 260px;
    background: ${COLORS.$white};
    border: 1px solid ${COLORS.$gray15Black};
    border-radius: 8px;
`;

export const ChartArea = styled.div`
    width: 100%;
    height: 80px;
    position: relative;
    overflow: hidden;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    flex: none;
    order: 0;
    flex-grow: 0;
`;

export const TextContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    padding: 0px;
    gap: 8px;
    width: 406px;
    height: 108px;
    flex: none;
    order: 1;
    flex-grow: 0;
`;

export const TitleText = styled(Typography.Title)`
    &&& {
        font-size: 20px;
        line-height: 28px;
        font-weight: 500;
        color: ${COLORS.$gray100Black};
        margin: 0;
    }
`;

export const DescriptionText = styled(Typography.Text)`
    &&& {
        font-size: 16px;
        line-height: 24px;
        color: ${COLORS.$gray60Black};
        display: flex;
        align-items: center;
    }
`;

export const ButtonsContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 0px;
    gap: 24px;
    width: 454px;
    height: 136px;
`;

export const PrimaryButton = styled(Button)`
    &&& {
        box-sizing: border-box;
        width: 454px;
        height: 56px;
        background: ${COLORS.$pinkGradient};
        border: 2px solid ${COLORS.$pink};
        border-radius: 8px;
        padding: 0px 16px;
        gap: 8px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;

        &:hover {
            background: ${COLORS.$pinkGradient};
            border-color: ${COLORS.$pink};
            opacity: 0.9;
        }

        &:active {
            background: ${COLORS.$pinkGradient};
            border-color: ${COLORS.$pink};
        }
    }
`;

export const SecondaryButton = styled(Button)`
    &&& {
        width: 454px;
        height: 56px;
        padding: 0px 16px;
        gap: 8px;
        display: flex;
        flex-direction: row;
        align-items: center;
        background: transparent;
        border: none;
        box-shadow: none;

        &:hover {
            background: transparent;
            box-shadow: none;
        }
    }
`;

export const SecondaryButtonText = styled.span`
    width: 422px;
    height: 24px;
    font-size: 16px;
    line-height: 24px;
    font-weight: 500;
    text-align: center;
    color: ${COLORS.$gray60Black};
`;
